import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import './optimisation-container.scss';
import { default as t } from '../../../utils/i18n';
import { Button } from '../../atoms';
import { DashService } from '../../../services';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { EmailTooltip, SearchBar, Dropdown, HelpPdfDownload } from '../../atoms/index';
import Box from '@material-ui/core/Box';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import { UserContext } from '../../../context';
import { useDebounceEffect } from '../../../hooks';
import { LiveCampaigns } from '../index';
import fileDownload from 'js-file-download';
import axios from '../../../utils/axios';
import { createPostTrackUsagePayload, UsageIdentifierFlow } from '../../../utils/misc';
import { postTrackUsageAPI } from '../../../services/dash.service';

const OptimisationContainer = props => {
  const history = useHistory();
  const [tabValue, setTabValue] = useState('1');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [filterBy, setFilterBy] = useState(null);
  const { user, setUser } = useContext(UserContext);
  const [liveCampaignData, setLiveCampaignData] = React.useState([]);
  const [completedCampaign, setCompletedCampaign] = React.useState([]);
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const username = user?.username;
  const authenticated = user?.authenticated;
  const [dropdownFilterby, setDropdownFilterby] = useState(0);
  const filterOption = [
    ['campaign_name', 'campaign_id', 'objective', 'kpi'],
    ['campaign_name'],
    ['campaign_id'],
    ['objective'],
    ['kpi'],
  ];
  const options = [
    { value: 0, label: t('reportTable.text.all') },
    { value: 1, label: t('perf.campaign.name') },
    { value: 2, label: t('perf.con.campaign.id') },
    { value: 3, label: t('campaign.details.Objective') },
    { value: 4, label: t('perf.con.kpi') },
  ];
  const [adAccounts, setAdAccounts] = useState([]);
  const [completedCount, setCompletedCount] = React.useState(0);
  const [liveCount, setLiveCount] = React.useState(0);
  const liveCampaignType = 'live';
  const completedCampaignType = 'completed';
  const [selectedAdAccount, setSelectedAdAccount] = useState('');
  // {value:'act_453481872591152'}
  const [businessManagers, setBusinessManagers] = useState([]);
  const [selectedBM, setSelectedBM] = useState('');

  const handleChange = (event, newValue) => {
    setTabValue(Number(newValue));
    handleDropdownOnChange(options[0]);
    handleSearchOnChange('');
    if (Number(newValue) === 1) {
      // getReports();
    } else {
      // getSharedReports();
    }
  };
  const onTableUpdate = event => {
    if (event) {
      // getReports();
    }
  };

  const onRowClicked = event => {
    if (event) {
      props.onTableRowclicked(event);
    }
  };

  const onImportClick = event => {
    if (event) {
      history.push('/import-campaigns');
    }
  };

  useEffect(() => {
    //console.log(options[0].value,'options[0].value');
    setFilterBy(options[0]);
    if (authenticated) {
      // getReports();
    }
  }, []);

  useEffect(() => {
    getBusinessManager();
    if (authenticated) {
      // getReports();
    }
  }, [props.onUpdateTable]);

  useEffect(() => {
    if (selectedAdAccount) {
      const selectedAdAccountId = [selectedAdAccount?.value] || [];

      const localStorageUserObj = localStorage.getItem('user');
      const { usageAPIPayload, updatedLocalStorageUserValue } = createPostTrackUsagePayload(
        selectedAdAccountId,
        JSON.parse(localStorageUserObj),
        UsageIdentifierFlow.AD_ACCOUNT
      );

      if (usageAPIPayload.ids.length) {
        postTrackUsageAPI(userAccessToken, username, {
          ...usageAPIPayload,
          userFlow: `optimization`,
        });
      }
      localStorage.setItem('user', JSON.stringify(updatedLocalStorageUserValue));
      setUser(updatedLocalStorageUserValue);
    }
  }, [selectedAdAccount]);

  const handleSearchOnChange = searchText => {
    setSearchKeyword(searchText);
  };
  const handleDropdownOnChange = dropdwnVal => {
    //console.log(dropdwnVal);
    setFilterBy(dropdwnVal);
    setDropdownFilterby(dropdwnVal.value);
  };

  async function getBusinessManager() {
    try {
      const bmResponse = await DashService.bmList(userAccessToken, username);
      let businessManagersList = bmResponse.data?.data?.map(businessMs => ({
        value: businessMs.id,
        label: businessMs.name,
      }));
      setBusinessManagers(businessManagersList);
      if (user.dropdowns?.businessManager) {
        setSelectedBM(user.dropdowns?.businessManager);
        getAdAccounts(user.dropdowns?.businessManager);
      } else {
        setSelectedBM(businessManagersList[0]);
        getAdAccounts(businessManagersList[0], false);
      }
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  async function getAdAccounts(selectedOption, selectFromContext = true) {
    try {
      const adAcResponse = await DashService.adAccountList(
        userAccessToken,
        username,
        selectedOption.value
      );
      let adAccountList = adAcResponse.data?.data?.map(adAccounts => ({
        value: adAccounts.id,
        label: adAccounts.name,
      }));
      setAdAccounts(adAccountList);
      if (selectFromContext && user.dropdowns?.adaccount) {
        setSelectedAdAccount(user.dropdowns?.adaccount);
      } else {
        setSelectedAdAccount('');
        setUser(prevUserState => ({
          ...prevUserState,
          dropdowns: {
            businessManagers: selectedOption,
            adaccount: '',
          },
        }));
      }
    } catch (error) {
      const dataCode = error?.data?.data?.code;
      if (dataCode) {
        //console.log(dataCode);
      }
    }
  }

  const handleOnSelectBM = selectedOption => {
    setLiveCount(0);
    setCompletedCount(0);
    setSelectedBM(selectedOption);
    getAdAccounts(selectedOption, false);
    clearSearch();
  };

  const handleOnSelectAdAccount = selectedOption => {
    setSelectedAdAccount(selectedOption);
    clearSearch();
    setUser(prevUserState => ({
      ...prevUserState,
      dropdowns: {
        adaccount: selectedOption,
        businessManager: selectedBM,
      },
    }));
  };

  const updateCount = (count, type) => {
    if (type === liveCampaignType) {
      setLiveCount(count);
    } else {
      setCompletedCount(count);
    }
  };

  const clearSearch = () => {
    setSearchKeyword('');
    setFilterBy(options[0]);
    setDropdownFilterby(0);
    setTabValue('1');
  };

  const handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: 'blob',
      })
      .then(res => {
        fileDownload(res.data, filename);
      });
  };

  return (
    <section className={`report-container`}>
      <div className="header-container">
        <div className="header-holder-optimize">
          <h2>{t('performance.opimisation')}</h2>
          <p>{t('perf.identify.sub.header')}</p>
        </div>
        <HelpPdfDownload />
      </div>
      <div className="import-campaign-cta">
        <Button
          type="button"
          label={t('perf.import.campaigns')}
          handleClick={onImportClick}
        ></Button>
        <i
          className="eva eva-arrow-circle-right icon-forward"
          onClick={event => {
            onImportClick(event);
          }}
        ></i>
        {/* <ExpandMoreIcon /> */}
      </div>
      <div className="listing-container optimisation">
        <div className="filter-section">
          <div className="left-section">
            <div style={{ width: '189px', height: '67px' }}>
              {/* <label>{t('advertiser')}</label> */}
              <Dropdown
                className="user-select"
                heading={t('perf.business.manager')}
                value={selectedBM}
                options={businessManagers}
                onSelect={handleOnSelectBM}
                placeholder={t('create.report.share.modal.placeholder1')}
                tooltipIndicator={true}
                tooltipId={t('business-manager')}
                infoData={t('optimisation.table.businessManager')}
              />
            </div>
            <div className="ad-account" style={{ width: '306px', height: '67px' }}>
              {/* <label>{t('Ad account')}</label> */}
              <Dropdown
                // className="ad-account"
                heading={t('perf.ad.account')}
                value={selectedAdAccount}
                options={adAccounts}
                onSelect={handleOnSelectAdAccount}
                placeholder={t('search.for.adaccount')}
                tooltipIndicator={true}
                searchIndicator={true}
                tooltipId={t('ad-account')}
                infoData={t('optimisation.table.adAccount')}
                search={true}
              />
            </div>
          </div>
          <div>
            <SearchBar
              onChange={handleSearchOnChange}
              value={searchKeyword}
              onDropdownChange={handleDropdownOnChange}
              options={options}
              filterBy={filterBy}
            />
          </div>
        </div>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={tabValue.toString()}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleChange} aria-label={t('insights.report.list.heading')}>
                <Tab
                  label={
                    <React.Fragment>
                      <span className="text">{t('perf.live.campaigns')} </span>
                      <span>({liveCount})</span>
                      <EmailTooltip
                        id={t('live-campaigns')}
                        emailToolTip={t('optimisation.table.liveCampaign')}
                      />
                    </React.Fragment>
                  }
                  value="1"
                />
                <Tab
                  label={
                    <React.Fragment>
                      <span className="text">{t('perf.completed.campaigns')} </span>
                      <span>({completedCount})</span>
                      <EmailTooltip
                        id={t('completed-campaigns')}
                        emailToolTip={t('optimisation.table.completedCampaign')}
                      />
                    </React.Fragment>
                  }
                  value="2"
                />
              </TabList>
            </Box>
            <TabPanel value="1">
              {selectedAdAccount && (
                <LiveCampaigns
                  selectedAdAccount={selectedAdAccount}
                  campaignType={liveCampaignType}
                  updateCount={updateCount}
                  searchKeyword={searchKeyword}
                  filterBy={filterOption[dropdownFilterby]}
                  dropdownFilterby={dropdownFilterby}
                />
              )}
            </TabPanel>
            <TabPanel value="2">
              {selectedAdAccount && (
                <LiveCampaigns
                  selectedAdAccount={selectedAdAccount}
                  campaignType={completedCampaignType}
                  updateCount={updateCount}
                  searchKeyword={searchKeyword}
                  filterBy={filterOption[dropdownFilterby]}
                  dropdownFilterby={dropdownFilterby}
                />
              )}
            </TabPanel>
          </TabContext>
        </Box>
      </div>
    </section>
  );
};

export default OptimisationContainer;
